<template>
    <div :class="{ pageWrapper: !asComponent }">
        <div class="container-wrapper">
            <div class="text-center w-100 mt-4">
                <h1 class="heading-with-underline">{{ fundOrScheme }} Information</h1>
            </div>
            <div class="input-wrapper flex container">
                <div class="input-with-icon">
                    <input v-model="filterText" placeholder="Search for a term..." />
                </div>
            </div>
            <div class="container px-0">
                <div class="key-information" id="key-information" v-masonry transition-duration="0.3s" item-selector=".key-information-card">
                    <KeyInformationCard v-for="(schemeDoc, schemeIndex) in filteredSchemeDocs" :schemeDoc="schemeDoc" :key="schemeIndex"
                        @videoModal="showVideoModal" :filterText="filterText" :maxLinkDisplay="maxLinkDisplay" />
                </div>
                <div class="no-results-warn" v-if="filteredSchemeDocs.length === 0 && filterText.length > 2">There are no matches for your query</div>
            </div>
        </div>

        <div class="videoModal" v-if="showModal">
            <div class="modalBg" />
            <div class="videoHolder">
                <div class="close" @click="showModal = false"><span class="icon-x"></span></div>
                <div v-html="video" />
            </div>
        </div>
    </div>
</template>

<script>

import KeyInformationCard from '@/components/newHomepage/KeyInformationCard.vue';

export default {
    data () {
        return {
            filterText: '',
            showModal: false,
            video: null,
        };
    },
    props: ['asComponent'],
    components: {
        KeyInformationCard,
    },
    metaInfo () {
        return {
            title: `${this.$store.state.clientConfig.fundOrScheme} information - ${this.$store.state.clientConfig.schemeName}`,
        };
    },
    computed: {
        schemeInfoDocs () {
            return this.$store.getters['clientConfig/clientConfig'].schemeDocs.filter(doc => doc.live);
        },
        maxLinkDisplay () {
            const max = this.$store.getters['clientConfig/clientConfig'].schemeDocsMaxLinkDisplay;
            return max > 0 ? max : 3;
        },
        filteredSchemeDocs () {
            let filterArray = [];
            if (this.filterText !== '' && this.filterText.length > 2) {
                // search
                const lowerText = this.filterText.toLowerCase();
                filterArray = this.schemeInfoDocs.filter((schemeItem) => {
                    let match = false;
                    if (schemeItem.title.toLowerCase().search(lowerText) > -1) {
                        match = true;
                    } else if (schemeItem.snippet.toLowerCase().search(lowerText) > -1) {
                        match = true;
                    } else if (schemeItem.description && schemeItem.description.toLowerCase().search(lowerText) > -1) {
                        match = true;
                    } else if (schemeItem.links && schemeItem.links.length > 0) {
                        schemeItem.links.map((link) => {
                            if (link.text.toLowerCase().search(lowerText) > -1) {
                                match = true;
                            }
                            return null;
                        });
                    }
                    return match;
                });
            } else {
                filterArray = this.schemeInfoDocs;
            }
            return filterArray;
        },
        directoryUrl () {
            return this.$store.state.clientConfig.directoryUrl;
        },
        fundOrScheme () {
            return this.$store.state.clientConfig.fundOrScheme;
        },
    },
    methods: {
        filterDocs (filterType) {
            this.filterType = filterType.type;
            // this.$redrawVueMasonry('schemeInfoDocs');
        },
        showVideoModal (videoObj) {
            this.video = videoObj;
            this.showModal = true;
        },
    },
    watch: {
        filteredSchemeDocs () {
            setTimeout(() => {
                this.$redrawVueMasonry('key-information');
            }, 0);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_mixins.scss';

.pageWrapper {
    background-color: $sectionColor1;
}

.container-wrapper {
    max-width: 2000px;
    margin: auto;
}

.key-information {
    margin-top: 3rem;
    display: flex;
    flex-wrap: wrap;

    @include responsive('md') {
        margin-top: 1rem;
    }

    @include responsive('mdLandscape') {
        margin-top: 1rem;
    }

    @include responsive('sm') {
        margin-top: 0;
    }
}

.input-wrapper {
    position: relative;
    justify-content: center;
    margin-top: 20px;

}

.input-with-icon {
    position: relative;
    width: 30rem;
    // height: 2.5rem;

    border-radius: 0.5rem;
    z-index: 2;

    // overflow: hidden;
    input {
        width: 100%;
        height: 100%;
        padding: 1rem;
        border: 1px solid #e6e6e6;
        border-radius: inherit;

        &::placeholder {
            @include responsive("sm") {
                font-size: 0.9rem;
            }
        }
    }

}

.no-results-warn {
    text-align: center;
    font-size: 19px;
}


.videoModal {

    .modalBg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .5);
        z-index: 1;
        transition: all 1s ease-in-out;

    }

    .videoHolder {
        transition: all 1s ease-in-out;
        position: fixed;
        width: 800px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
        padding: 1.5rem;
        background: var(--greyColour);
        border-radius: 6px;

        .close {
            position: absolute;
            top: -20px;
            right: -20px;
            background: white;
            padding: 10px;
            border-radius: 50%;
            cursor: pointer;
            opacity: 1;
        }

        img {
            width: 100%;
        }
    }
}
</style>
